<ngx-simplebar
  class="ui-modal scrollbar-thin"
  [ngClass]="{'is-active': active, 'is-animate': isAnimate, 'ui-modal--fullscreen': fullscreen}"
  [attr.class]="classes"
>
  <div class="ui-modal__overlay" (click)="onClose()"></div>
  <div class="ui-modal__wrap">
    <div class="ui-modal__window">
      <div class="ui-modal__content">
        <button class="ui-modal__close" type="button" (click)="onClose()" >
          <app-ui-icon name="icon-cross" width="22"></app-ui-icon>
        </button>
        <ng-container *ngIf="title">
          <div class="ui-modal__header">
            <div class="ui-modal__container">
              <h2 class="ui-modal__title">{{ title }}</h2>
            </div>
          </div>
        </ng-container>
        <div class="ui-modal__body">
          <div class="ui-modal__container">
            <ng-content></ng-content>
          </div>
        </div>
      </div>
    </div>
  </div>
</ngx-simplebar>
